module.exports = __webpack_public_path__ + "img/be13689328d19299da63b2366f135597.svg";